class Property {
    constructor(
       { id, name, location, price, description, image, address, lat, lng,
        numBeds, numBaths, perimeter, publicationDate, authorId, isSponsored}
    ) {
        this.id = id;
        this.name = name;
        this.location = location;
        this.price = price;
        this.description = description;
        this.image = image;
        this.address = address;
        this.lat = lat;
        this.lng = lng;
        this.numBeds = numBeds;
        this.numBaths = numBaths;
        this.perimeter = perimeter;
        this.publicationDate = publicationDate;
        this.authorId = authorId;
        this.isSponsored = isSponsored;
    }

    // Ajoute des méthodes si nécessaire
    updateDetails(details) {
        Object.assign(this, details);
    }
}
export default Property;
